import { Component, Input, OnInit } from "@angular/core";
import { NbButtonModule, NbCardModule, NbDialogRef } from "@nebular/theme";
import { PanZoomComponent } from "../panzoom/pan-zoom.component";
import { NgIf } from "@angular/common";

@Component({
  selector: "ngx-process-model-popup",
  templateUrl: "./process-model-popup.component.html",
  styleUrls: ["./process-model-popup.component.scss"],
  imports: [NbCardModule, PanZoomComponent, NgIf, NbButtonModule],
})
export class ProcessModelPopupComponent implements OnInit {
  @Input() title: string;
  @Input() imageUrl: string;

  constructor(protected ref: NbDialogRef<ProcessModelPopupComponent>) {}

  ngOnInit() {}

  close() {
    this.ref.close();
  }
}
